
let AccessControlRoutes = [
  {
    path: '101',
    name: '101',
    component: () => import('@/pages/AccessControl/SystemParameter/SystemParameter')
  },
  {
    path: '201',
    name: '201',
    component: () => import('@/pages/AccessControl/InstitutionDateManage/InstitutionDateManage')
  },
  {
    path: '301',
    name: 'home301',
    component: () => import('@/pages/AccessControl/UserManage/UserManage')
  },
  {
    path: '302',
    name: '302',
    component: () => import('@/pages/AccessControl/RoleManage/RoleManage')
  },
  {
    path: '303',
    name: '303',
    component: () => import('@/pages/AccessControl/AuditLog/AuditLog')
  },
  {
    path: '401',
    name: '401',
    component: () => import('@/pages/AccessControl/DeviceData/DeviceData')
  },
  {
    path: '403',
    name: '403',
    component: () => import('@/pages/AccessControl/DoorOpenManage/DoorOpenManage')
  },
  {
    path: '404',
    name: '404',
    component: () => import('@/pages/AccessControl/HolidayManage/HolidayManage')
  },
  {
    path: '502',
    name: '502',
    component: () => import('@/pages/AccessControl/DepartmentPerson/DepartmentPerson')
  },
  {
    path: '601',
    name: '601',
    component: () => import('@/pages/AccessControl/PassRule/PassRule')
  },
  {
    path: '602',
    name: '602',
    component: () => import('@/pages/AccessControl/PassSetting/PassSetting')
  },
  {
    path: '603',
    name: '603',
    component: () => import('@/pages/AccessControl/PassSetting/TempPassSetting')
  },
  {
    path: '604',
    name: '604',
    component: () => import('@/pages/AccessControl/PassHistory/PassHistory')
  },
  {
    path: '605',
    name: '605',
    component: () => import('@/pages/AccessControl/RealTimeMonitoring/RealTimeMonitoring')
  },
  {
    path: '606',
    name: '606',
    component: () => import('@/pages/AccessControl/DataDownloadFail/DataDownloadFail')
  }
]

export {
  AccessControlRoutes
}



// WEBPACK FOOTER //
// ./src/router/AccessControlRoutes.js